<template>
  <NoticeBase
    :notice="notice"
    :relative-time="relativeTime"
    notice-class="inbox-generic-notice"
    @open="open"
    @archived="$emit('archived', $event)"
  >
    <span class="notice-icon" aria-hidden="true">
      <NoticeIcon />
    </span>
    <span class="text">{{ notice.message }}</span>
  </NoticeBase>
</template>

<script lang="ts">
import { defineComponent, PropType, toRef } from "vue";

import NoticeIcon from "@/components/icons/NoticeIcon.vue";
import {
  openNotice,
  useNoticeRelativeTime,
  type GenericNotice,
} from "@/components/inbox/notice";
import NoticeBase from "@/components/inbox/NoticeBase.vue";
import * as inject from "@/components/inject";

export default defineComponent({
  name: "InboxGenericNotice",
  components: { NoticeBase, NoticeIcon },
  props: {
    notice: {
      type: Object as PropType<GenericNotice>,
      required: true,
    },
  },
  emits: {
    archived: (_noticeId: string) => true,
  },
  setup(props) {
    const controller = inject.controller();
    const logger = inject.logger();
    const router = inject.router();

    const noticeRef = toRef(props, "notice");
    const relativeTime = useNoticeRelativeTime(noticeRef);

    const open = async () => {
      await openNotice(controller, router, logger, props.notice);
    };

    return {
      open,
      relativeTime,
    };
  },
});
</script>

<style scoped lang="scss">
.notice-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
}

.notice-icon :deep(svg) {
  width: 18px;
  height: 18px;
}

.text {
  margin-inline-start: 6px;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @include themed() {
    color: t($grey-90);
  }
}
</style>
